import { User } from "../../types";

export enum USERS_ACTIONS {
  USERS_LOADED_SUCCESS = "USERS_LOADED_SUCCESS",
  USERS_LOADED_FAILED = "USERS_LOADED_FAILED",
  USERS_LOADING = "USERS_LOADING",
  USERS_MUTATION_LOADING = "USERS_MUTATION_LOADING",
  USERS_MODAL = "USERS_MODAL",
}

export interface userState {
  users: User[];
  showModal: boolean;
  isLoading: boolean;
  isMutationLoading: boolean;
  error: { [x: string]: string } | string | null;
}

const initialState: userState = {
  users: [],
  isLoading: false,
  showModal: false,
  isMutationLoading: false,
  error: null,
};

export interface UserActionType {
  type: keyof typeof USERS_ACTIONS;
  payload: any;
}

const JobReducer = (
  state: userState = initialState,
  action: UserActionType
): userState => {
  switch (action.type) {
    case USERS_ACTIONS.USERS_LOADED_SUCCESS:
      return {
        ...state,
        users: action.payload,
        isLoading: false,
      };

    case USERS_ACTIONS.USERS_LOADED_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case USERS_ACTIONS.USERS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case USERS_ACTIONS.USERS_MUTATION_LOADING:
      return {
        ...state,
        isMutationLoading: action.payload,
      };

    case USERS_ACTIONS.USERS_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default JobReducer;
